import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Welcome from '../components/welcome/Welcome'
import { getTiers } from '../store/actions/main'
import { selectMainProfile } from '../store/selectors/common'

const WelcomeContainer = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const mainProfile = useSelector(selectMainProfile)

  useEffect(() => {
    dispatch(getTiers())
  }, [])

  return <Welcome t={t} tiers={mainProfile.tiers} />
}

export default WelcomeContainer
